import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';
import { PaginationModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AlertModule } from 'ngx-bootstrap/alert';
import { RouteReuseStrategy } from '@angular/router';
import { PRODUCTPROVIDERLIST_ROUTER_PROVIDERS } from './productproviderlist.routes';

import { CustomReuseStrategy } from '../common/route.reuse';

import { ProductProviderListComponent } from './productproviderlist.main';
import { ProductProviderList } from './productproviderlist.list';

import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { HttpClientModule } from '@angular/common/http';
import { ProviderProductDetailModule } from '../providerproductdetail/providerproductdetail.module';

@NgModule({
    declarations: [ProductProviderListComponent, ProductProviderList],
    imports: [
        BrowserModule,
        PRODUCTPROVIDERLIST_ROUTER_PROVIDERS,
        FormsModule,
        HttpModule,
        ProviderProductDetailModule,
        HttpClientModule,
        PaginationModule.forRoot(),
        AlertModule.forRoot(),
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        MDBBootstrapModule.forRoot(),
    ],
    providers: [
        SiteServices,
        { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    ],
    bootstrap: [ProductProviderListComponent],
})
export class ProductProviderListModule {}
